'use client'

import * as React from 'react'
import { cn } from '../../../lib/utils'
import { abbreviateCount } from '../../../lib/formatCount'
import { buttonVariants } from '../Button'
import { badgeVariants } from '../Badge'

export interface BreadcrumbTriggerProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  pageName: string
  count?: number
  isOpen?: boolean
}

export const BreadcrumbTrigger = React.forwardRef<
  HTMLButtonElement,
  BreadcrumbTriggerProps
>(function BreadcrumbTrigger(
  { pageName, count, isOpen, className, type = 'button', ...props },
  ref,
) {
  const formattedCount =
    count !== undefined ? abbreviateCount(count) : undefined

  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        buttonVariants({ variant: 'ghost', size: 'sm' }),
        'inline-flex h-7 min-h-7 items-center gap-1.5 -ml-2 px-2 py-0 text-sm font-normal text-muted-foreground',
        isOpen && 'bg-accent text-accent-foreground',
        className,
      )}
      aria-expanded={isOpen}
      aria-haspopup="dialog"
      {...props}
    >
      <span>{pageName}</span>

      {formattedCount !== undefined && (
        <span
          className={cn(
            badgeVariants({ variant: 'secondary', size: 'sm' }),
            'h-5 min-w-5 shrink-0 justify-center rounded-md px-1.5',
            'text-[10px] leading-none tabular-nums font-semibold',
          )}
        >
          {formattedCount}
        </span>
      )}
    </button>
  )
})
